import { createFileRoute } from '@tanstack/react-router';
import { ensureLoaded } from '@/lib/ensure-loaded';
import { reviewQueueQuery } from '@/services/review';
import { myRoleQuery } from '@/services/team-members';
import { ReviewLandingFor } from '@/features/operator/operator-review-landing';

// The Review disc's page: what has waited longest, else "You're all caught up" (Operations, 10 Oct 2026).
export const Route = createFileRoute('/_authed/review/')({
  loader: ({ context: { queryClient, team } }) =>
    team ? Promise.all([ensureLoaded(queryClient, reviewQueueQuery(team.id)), ensureLoaded(queryClient, myRoleQuery(team.id)).catch(() => null)]) : undefined,
  component: ReviewLandingFor,
});
